/* eslint-disable quotes, quote-props, comma-dangle  */
import type { TranslationProps } from './types';

export const translations = {
  "cancel_button_label": [
    {
      "type": 0,
      "value": "Cancelar"
    }
  ],
  "warning_body_list_item_one": [
    {
      "type": 0,
      "value": "obteve uma justificativa comercial para acessar os dados do cliente"
    }
  ],
  "warning_body_list_item_two": [
    {
      "type": 0,
      "value": "Sua atividade de download será registrada e rastreada para fins de conformidade de segurança"
    }
  ],
  "warning_footer": [
    {
      "type": 0,
      "value": "Deseja continuar?"
    }
  ],
  "warning_header": [
    {
      "type": 0,
      "value": "Ao fazer o download, você reconhece que:"
    }
  ]
};

function TranslationProviderComponent({ children }: TranslationProps) {
  return children(translations);
}

export default Object.assign(TranslationProviderComponent, { translations });
